export const serviceInformation = {
  // Copied verbatim from miniapp pages/agreement/agreement.wxml (privacy, 2026-09-21).
  // This is a reviewed Web-owned copy, not a cross-client runtime import.
  privacy: {
    "title": "Mirafans·镜界隐私政策",
    "updatedAt": "更新日期：2026年09月21日",
    "scopeNote": "沿用小程序现有版本。网站手机号注册及刷脸认证的相关说明仍需补充；刷脸认证前另行告知并征得同意。",
    "description": "本平台高度重视您的个人信息保护。本政策说明我们如何收集、使用、存储和保护您的个人信息，尤其是人脸等敏感信息。",
    "sections": [
      [
        "一、我们收集的信息",
        "1.1 账号信息：微信登录标识（OpenID）用于识别当前账号；您填写或选择的昵称、头像用于个人资料展示。\n\n1.2 签约登记信息：姓名、身份证号、手机号及短信验证码，用于签约人信息登记、手机号验证和合同关联。当前登记流程不提供人脸识别、活体核验或姓名与身份证权威库比对；不收集身份证照片、手持证件照或用于核身的免冠照片。拒绝登记时仍可浏览公开内容，但不能完成需要签约的形象提交。\n\n1.3 形象照片及选填展示视频：照片用于生成标准形象；照片和视频用于内容审核、公开展示，并在授权生效后随下单快照提供给获授权企业。视频上传开放时可选填 MP4/MOV 视频（不限制编码，最长30秒、最大100MB）。素材可能包含人脸和声音；不用于人脸识别、活体核验或身份比对。\n\n1.4 企业信息：企业名称、统一社会信用代码、营业执照、联系人及电话（仅企业用户）。\n\n1.5 签约、交易与提现记录：手写签名、合同编号、授权范围和期限、订单、历史收支、持卡人姓名、开户银行及银行卡号，用于履行已确认的协议、收益提现、对账和争议处理。绑定银行卡时不额外收集身份证号或银行预留手机号；持卡人姓名必须与当前签约身份一致。"
      ],
      [
        "二、信息的使用",
        "2.1 用于提供形象上传、AI 标准化、授权撮合与合同签署等核心服务。\n\n2.2 您选择的形象照片会上传至腾讯云存储，并通过微信内容安全能力及阿里云通义视觉模型进行图片质量与内容检查；选择 AI 标准化时，相应图片会交由阿里云通义服务处理。照片检查用于判断清晰度、构图等素材质量，不用于确认某个人的真实身份。\n\n2.3 上传前可拒绝素材处理并继续浏览。平台内的授权素材下载入口按有效授权校验，但形象素材文件本身公开可读，任何拿到链接的人都可查看或下载，包括待审核、驳回或移除展示后仍保留的文件。公开读取不代表获得商业使用许可，商用仍须申请授权；请仅提供本人有权上传且接受公开读取的素材。\n\n2.4 微信提供登录与内容安全能力，腾讯云提供云存储、云函数及短信服务，阿里云通义服务用于上述 AI 图片处理。处理范围以您实际使用的功能为限；短信验证会向短信服务提供手机号，图片处理会传输相应图片。"
      ],
      [
        "三、信息的存储与保护",
        "3.1 您的照片、视频与业务信息保存在腾讯云服务中；账号及业务数据按身份和授权控制访问，形象照片及视频文件不提供私密存储保证。审核决定是否上架展示，不阻止已持有文件链接者读取。请勿在形象素材中上传证件或不希望公开的私人内容。\n\n3.2 视频功能开放时可在形象管理中上传、替换或移除视频，修改后须重新审核；移除展示不等于删除原文件或使原链接失效。为履行已经生效的授权、争议处理和法定义务，下单时固化的历史素材可能按授权期限及法定留存要求继续保存。\n\n3.3 我们不会将您的可识别人脸信息出售给任何第三方。\n\n3.4 完整银行卡号以独立密钥加密保存，普通记录仅显示首四位和尾四位；仅经授权管理员处理待审核或待打款申请时可查看必要信息，访问会记录审计日志。"
      ],
      [
        "四、您的权利",
        "4.1 您可以在“我的”和“形象管理”查看、更正资料；涉及实名登记、授权、删除或撤回同意的问题，可通过本页客服入口提出申请。手机相机、相册等权限也可在微信或手机设置中撤回。\n\n4.2 您可以按页面提供的操作申请下架或删除形象。已生效合同及授权涉及的原文件、历史快照不因修改展示素材而自动删除；具体处理范围需结合有效合同和留存义务确认。\n\n4.3 “我的 → 注销账号”会结束当前账号业务周期，并将当前业务资料归档；它不等于立即物理删除全部历史记录。平台仍保留历史合同、授权、收支和身份关联记录用于历史业务查询、履约及争议处理；如需进一步处理个人信息，请联系客服说明请求。"
      ],
      [
        "五、未成年人保护",
        "本平台不向未满 18 周岁的未成年人提供形象授权服务。"
      ],
      [
        "六、联系我们",
        "如需查询、更正、删除个人信息、撤回同意或处理注销后的历史记录，请使用下方客服入口。请说明相关功能和请求，不要在首次咨询时发送完整身份证号、银行卡号或证件照片。"
      ]
    ]
  },
  terms: {
    title: "授权服务说明",
    description: "购买前请核对具体订单与正式约定。以下说明当前流程，正式服务条款仍待核准。",
    sections: [
      ["申请与付款", "选择形象后填写项目、角色及用途。订单金额由服务端核对并保存；付款后由创作者确认申请。付款成功并不等于授权已生效。"],
      ["授权与素材", "使用范围、期限、渠道、地域及交付内容应以双方确认的订单和正式约定为准。授权确认、合同手续及有效状态满足条件后，订单才提供相应素材下载。"],
      ["合同记录", "平台内生成的流程记录用于保存申请、付款与确认信息，不应被理解为已取得第三方电子签名或其他资质证明。"],
      ["开放条件", "经营与收款主体、正式套餐范围、签约安排、发票及客服信息核准后，才会正式开放相应网页交易入口。网页 H5 支付还需微信商户平台开通与实际验收。"],
    ],
  },
  "refund-policy": {
    title: "取消与退款说明",
    description: "本页说明订单状态含义。新交易付款后 24 小时内未获创作者回应，将自动发起原路全额退款；到账以支付渠道结果为准。",
    sections: [
      ["尚未付款", "取消申请时先核对原支付单。付款链接过期或页面关闭，都不代表微信支付单已关闭。结果不明时，请勿另外创建订单重复付款。"],
      ["创作者未回应", "采用 24 小时回复规则的新订单，从平台确认付款成功起计时，满 24 小时未回应自动发起原路全额退款。系统定时处理，发起退款不等于即时到账；历史订单按原约定处理。"],
      ["已经付款", "请从原订单发起退款申请或查看处理进度。创作者确认后的退款进入人工审核；审核通过、提交退款与退款到账是不同状态。"],
      ["处理结果", "处理中或结果待核对时，保留原订单与退款单号继续查询，不重复退款。以支付渠道确认的最终结果为准，不以页面跳转或提交成功作为到账证明。"],
      ["素材使用", "退款申请处理中会限制新的授权素材下载。已经下载的文件无法由平台远程收回，后续使用与停止使用的义务需按正式约定处理。"],
    ],
  },
  support: {
    title: "客服与订单帮助",
    description: "添加微信 Mira_AI001，可咨询客服。",
    sections: [
      ["查询原订单", "网站企业账号可在“企业授权素材”查看订单，创作者可在“收到的授权申请”查看申请。也可以在关联的小程序身份下查看同一笔记录。"],
      ["反馈时提供什么", "请准备订单号、操作时间、页面显示的状态与问题说明。不要发送支付密码、验证码、私钥、API 密钥或完整证件信息。"],
      ["付款结果不明", "若微信已经扣款但页面尚未更新，请保留原订单，稍后查询并联系平台核对，勿重复付款。可添加微信 Mira_AI001 联系客服核对。"],
    ],
  },
} as const;
